export default "__VITE_ASSET__1XXXUhLq__"